module.exports = __webpack_public_path__ + "img/Asso_WM_02.6eeb1a57.jpg";